import { Component, inject } from '@angular/core';
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { LoginService } from '../login/login.service';

@Component({
  selector: 'app-idle',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './idle.component.html',
  styleUrl: './idle.component.css'
})
export class IdleComponent {
  private loginService = inject(LoginService);
  private idle = inject(Idle);
  private keepalive = inject(Keepalive);
  private cd = inject(ChangeDetectorRef);
  private snackBar = inject(MatSnackBar);
  private timeInactive: number = 3600; //1200;
  private timeWarning: number = 60;

  // CAMPOS PARA PRESENTAR EN PANTALLA
  public idleState = "NOT_STARTED";
  public inactive: number = this.timeInactive;
  public countdown: number = this.timeWarning;
  public lastPing: Date = new Date();

  constructor() {
    // SET PARAMETROS DE IDLE
    this.idle.setIdle(this.timeInactive);
    this.idle.setTimeout(this.timeWarning);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // INICIALIZAMOS EL IDLE
    this.idle.onIdleStart.subscribe(() => {
      this.idleState = "USER_INACTIVE";
      this.lastPing = new Date();
      this.countdown = this.timeWarning;
    });

    // EL USUARIO VUELVE A TENER ACTIVIDAD
    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = "USER_ACTIVE";
      this.lastPing = new Date();
      this.countdown = this.timeWarning;
      this.cd.detectChanges();
      this.openSessionActiva();
    });

    // AL USUARIO SE LE HA ACABADO EL TIEMPO DE ESPERA
    this.idle.onTimeout.subscribe(() =>  {
      this.idleState = "USER_INACTIVE_TIMED_OUT";
      this.countdown = 0;
      this.openLogout();
      this.loginService.logout();
    });

    // EMPEZAMOS EL CONTEO DE ALERTA
    this.idle.onTimeoutWarning.subscribe(seconds => {
      this.idleState = "USER_INACTIVE_TIMED_WARNING";
      this.countdown = seconds;
      this.openCountDown();
    });

    // SET PARAMETROS PARA KEEPALIVE
    this.keepalive.interval(60);
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date() );
  }

  reset() {
    this.idleState = "USER ACTIVE";
    this.idle.watch();
  }

  openSessionActiva() {
    this.snackBar.open('REGRESASTE!!!', '', {
      verticalPosition: 'top',
      horizontalPosition: 'center',
      duration: 3000
    });
  }

  openLogout() {
    this.snackBar.open('SESIÓN CERRADA POR INACTIVIDAD', 'CERRAR', {
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  openCountDown() {
    this.snackBar.open('CERRANDO SESIÓN EN ' + this.countdown.toString() + ' SEGUNDOS', '', {
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  ngOnInit(): void {
    this.reset();
    this.snackBar.dismiss();
  }

  ngOnDestroy(): void {
    this.idle.stop();
  }
}
